import Events from '../lib/events';

export default class InputSelect {
  static params = {
    inputSelector: 'select',
    fieldSelector: '.js-select-field'
  };

  constructor($container) {
    this.$container = $container;
    this.$element = this.$container.querySelector(InputSelect.params.inputSelector);
    this.$field = this.$container.querySelector(InputSelect.params.fieldSelector);
    this.events = new Events(this.$container);

    this.bindEvents();

    this.update();
  }

  bindEvents() {
    this.events.bind('change', InputSelect.params.inputSelector, (event) => {
      this.update();
    });
  }

  update() {
    var options = [];
    var $options = this.$element.querySelectorAll('option');
    $options.forEach(($option) => {
      if (!$option.disabled && $option.selected) {
        options.push($option.textContent.trim());
      }
    });

    if (!options.length) {
      options.push($options[0].textContent.trim());
    }

    this.$field.textContent = options.join(', ');
    this.$field.title = options.join(', ');
  }

  static initAll(selector) {
    document.querySelectorAll(selector).forEach(($container) => {
      new InputSelect($container);
    });
  }
}
